// UTMB Internal Alert System

(function (config) {

    if (config.useUtmbAlertSystem && (!config.pageIsDesignMode || config.pageIsPreviewMode))
    {
        // function setInternalAlertsTab(resp) {
        //     if (resp) {
        //         var header = document.getElementById("header");
                
        //         var alertSystem = document.createElement("DIV");
        //         alertSystem.id = "utmbAlertSystem";
        //         var alertTab = document.createElement("DIV");
        //         var alertTabLink = document.createElement("A");
        //         alertTabLink.id = "alert-side-tab";
        //         alertTabLink.classList.add("uk-badge");
        //         alertTabLink.classList.add("badge");
        //         alertTabLink.setAttribute("uk-toggle","target: #alert-tab-modal");
        //         var alertTabContents = document.createElement("SPAN");
        //         var alertTabBadge = document.createElement("SPAN");
        //         var alertTabIcon = document.createElement("SPAN");
        //         var alertTabTitle = document.createElement("SPAN");

        //         // internal alert modal

        //     }
        // }

        function setInternalAlerts(resp) {
            var alertsList = document.getElementById('alertsList');
            if (resp) {
                //var alertsList = document.getElementById('alertsList');
                var i, alertCount = 0;
                var alerts = JSON.parse(resp);

                for (i = 0; i < alerts.length; i++) {
                    var msg = alerts[i].UtmbAlertMessages;
                    alertCount += msg.length; // count
                }

                if (alertCount > 0) {
                    for (i = 0; i < alerts.length; i++) {

                        // li
                        var li = document.createElement("LI");
                        li.className = alerts[i].AlertCatThreatLevel.toLowerCase() + "-alert";

                        // cat
                        var cat = document.createElement("P");
                        cat.className = "alert-category";

                        // cat text
                        var catText = document.createElement("SPAN");
                        catText.className = "alert-category-text";
                        var catTextNode = document.createTextNode(alerts[i].AlertCatTitle);
                        catText.appendChild(catTextNode);
                        cat.appendChild(catText);

                        // cat badge
                        var catBadge = document.createElement("SPAN");
                        catBadge.classList.add("uk-badge");
                        catBadge.classList.add("badge");
                        var catBadgeNode = document.createTextNode(alerts[i].UtmbAlertMessages.length);
                        catBadge.appendChild(catBadgeNode);
                        cat.appendChild(catBadge);

                        // contents
                        var contents = document.createElement("DIV");
                        contents.className = "alert-contents";
                        var container = document.createElement("DIV");
                        container.className = "alert-msg-container";

                        // messages
                        var alertMessages = alerts[i].UtmbAlertMessages;
                        for (x = 0; x < alertMessages.length; x++) {

                            // title
                            var alertTitle = document.createElement("P");
                            alertTitle.className = "alert-msg-title";
                            var alertTitleNode = document.createTextNode(alertMessages[x].AlertTitle);
                            alertTitle.appendChild(alertTitleNode);
                            container.appendChild(alertTitle);

                            // meta
                            var alertMeta = document.createElement("P");
                            alertMeta.className = "alert-msg-meta";
                            var alertMetaText = alertMessages[x].AlertPostDate + " • " +
                                alertMessages[x].AlertPostTime + " • " + alertMessages[x].AlertUsername;
                            var alertMetaNode = document.createTextNode(alertMetaText);
                            alertMeta.appendChild(alertMetaNode);
                            container.appendChild(alertMeta);

                            // mesage
                            var alertMessage = document.createElement("P");
                            alertMessage.className = "alert-msg";
                            var alertMessageNode = document.createTextNode(alertMessages[x].AlertMessage);
                            alertMessage.appendChild(alertMessageNode);
                            container.appendChild(alertMessage);
                        }

                        // build
                        li.appendChild(cat);
                        li.appendChild(container);
                        li.appendChild(contents);
                        alertsList.appendChild(li);
                    }

                    // Set Alert Tab Counter
                    var tabCounter = document.getElementById("alert-tab-counter");
                    var tabCount = document.createTextNode(alertCount);
                    tabCounter.appendChild(tabCount);

                    // Add .is-active class to alert system wrapper to show it
                    var utmbAlertSystem = document.getElementById("utmbAlertSystem");
                    utmbAlertSystem.className = "is-active";
                }
            } else {
                alertsList.remove();
            }
        }

        // var apiUri = "/api/UtmbAlerts/Get";
        var apiUri = config.utmbAlertSystemUri;
        if (this.isDevMode) apiUri = "http://localhost:60876" + apiUri; // Sitefinity ONLY!

        var request = new XMLHttpRequest();
        request.open('GET', apiUri, true);

        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                var resp = this.response;
                // setInternalAlertsTab(resp);
                setInternalAlerts(resp);
            } else {
                // We reached our target server, but it returned an error
                console.log("We reached our target server, but it returned an error.");
            }
        };

        request.onerror = function () {
            // There was a connection error of some sort
            console.log("Houston, we have a problem ... There was a connection error of some sort.");
        };

        request.send();
    }

})(window.utmbWeb);